import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import ItemGrid from '../../../components/itemGrid';
import CourseDescription from '../../../components/courseDescription';
import StretchScreen from '../../../components/strechSection';

export default function Page03({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<ItemGrid
				title='Food'
				rows={[
					['Protein', 'Carbohydrates', 'Fats'],
					['Chicken', 'Rice', 'Olive Oil'],
					['Ground Beef', 'Sweet Potatoes', 'Avocado'],
					['Steak', 'Oatmeal', 'Nuts'],
					['Ground Turkey', 'Baked Potatoes', 'Fats from Fish'],
					['Eggs', '', 'Fish Oil'],
					['Turkey Bacon', '', 'Flaxseed'],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Liquids', 'Minerals'],
					['WATER', 'Vitamin D '],
					['Pomegranate Juice', 'Magnesium'],
					['Beet Juice', 'Calcium'],
					['Orange Juice', 'Zinc'],
					['', 'Iron'],
					['', 'Folate'],
					['', 'Vitamin B - 12'],
				]}
			/>
			<h1 className='mt-5 nice-header text-center px-3 text-black'>INVENTORY</h1>
			<ItemGrid
				mt={true}
				title='Stretch Exercises'
				rows={[
					['Hips', 'Shoulders', 'Hamstrings'],
					['Knee to Chest Stretch', 'Thread the Needle', 'Lying hamstring stretch/Strap'],
					[
						'90/90 Stretch',
						'Elbow-Out Rotator Stretch Cross-Body Shoulder Stretch',
						'Sitting hamstring stretch',
					],
					['Figure Four Stretch', 'Cross-Body Shoulder Stretch', 'Standing Hamstring Stretch'],
					['Piriformis Stretch', 'Overhead Triceps and Shoulder Stretch', ''],
					['Lunging Hip Flexor Stretch', 'Reverse Shoulder Stretch', ''],
					['Pigeon Stretch', '', ''],
					['Spiderman Stretch', '', ''],
					['Butterfly Fly Stretch', '', ''],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Lower Back', 'Glutes', 'Quad'],
					['Knee to Chest Stretch', '90/90', 'Kneeling Lunge'],
					['Figure Four Stretch', 'Half Lord of the Fishes', 'Standing Quad Stretch'],
					['Piriformis Stretch', 'Lizard Pose Variation', ''],
					["Child's Pose", 'Pigeon Pose', ''],
					['Cobra Stretch', '', ''],
					['Bird-Dog Stretch', '', ''],
				]}
			/>
			<StretchScreen
				mt={true}
				title='YOU HAVE TO STRETCH!!!!'
				caption='Keep the muscles flexible, strong, and healthy, and we need that flexibility to maintain a range of motion in the joints. Without it, the muscles shorten and become tight. Then, when you call on the muscles for activity, they are weak and unable to extend all the way.'
				subTitle='FIVE BENEFITS'
				texts={[
					'* Stretching can improve posture. Tight muscles can cause poor posture',
					'* Stretching can improve the range of motion and prevents loss of range of motion.',
					'* Stretching decreases back pain',
					'* Stretching helps prevent injury',
					'* Stretching can decrease muscle soreness.',
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
